import { StreamActions } from "@hotwired/turbo"


StreamActions.open_next_unanswered = function() {
	const currentIndex = parseInt(this.getAttribute("current-index"))
	const nextIndex = currentIndex + 1

	// Trouver la frame avec le prochain index
	const nextFrame = document.querySelector(`[data-unanswered-index="${nextIndex}"]`)

	if (nextFrame) {
		const frameId = nextFrame.id
		const channelAccountId = this.getAttribute("channel-account-id")
		const interactionId = frameId.replace('new_reply_to_social_interaction_', '')

		// Charger le formulaire
		nextFrame.src = `/channel_accounts/${channelAccountId}/social_interactions/new?id=${interactionId}`

		// Scroll et focus
		setTimeout(() => {
			nextFrame.scrollIntoView({ behavior: 'smooth', block: 'center' })

			nextFrame.addEventListener('turbo:frame-load', () => {
				const textarea = nextFrame.querySelector('textarea')
				if (textarea) textarea.focus()
			}, { once: true })
		}, 100)
	}
}
